import axios from "axios";
import { newApiBaseUrl } from "../../axiosInstance";

export const OpenTextGet = (kind) => {
  return axios.get(`${newApiBaseUrl}/dict/${kind}`, {
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const OpenTextSet = (data) => {
  return axios.patch(`${newApiBaseUrl}/dict/${data.kind}/${data.id}`, data, {
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const addOpenText = (data) => {
  return axios.post(`${newApiBaseUrl}/dict/${data.kind}`, data, {
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};
export const deleteOpenText = (id, kind) => {
  if (!id || !kind) return Promise.reject("Missing ID or Kind");
  return axios.delete(`${newApiBaseUrl}/dict/${kind}/${id}`, {
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};
